export default {
    generateContentModal: {
        title: 'Gerar Conteúdo',
        type: 'Tipo',
        typePlaceholder: 'Selecionar tipo',
        typeEmptyError: 'Por favor, selecione o tipo',
        context: 'Contexto',
        contextPlaceholder: 'Selecionar contexto',
        contextEmptyError: 'Por favor, selecione o contexto',
        contentTitle: 'Título do conteúdo',
        contentTitlePlaceholder: 'Adicione o tema do seu conteúdo',
        contentTitleEmptyError: 'Por favor, introduza o título',
        contentTitleInvalidError: 'Por favor, introduza um título válido.',
        description: 'Fornecer uma breve descrição do conteúdo',
        descriptionPlaceholder: 'Adicione a descrição do seu conteúdo em 2-3 linhas',
        descriptionEmptyError: 'Por favor, introduza a descrição.',
        descriptionInvalidError: 'Por favor, introduza uma descrição válida.',
        addKeywords: 'Adicionar palavras-chave',
        addKeywordsEmptyError: 'Por favor, introduza as palavras-chave',
        writingTone: 'Tonalidade da Escrita',
        writingTonePlaceholder: 'Selecionar o tom de escrita',
        writingToneEmptyError: 'Por favor, selecione o tom de escrita.',
        numberOfVariations: 'Número de variações',
        numberOfVariationsEmptyError: 'Por favor, selecione o número de variação.',
        numberOfVariationsInvalidError: 'Pode gerar no máximo 5 e no mínimo 1 variação.',
        generate: 'Gerar',
        additionalOptions: 'Opções adicionais',
        clear: 'Claro',
        writingToneOptions: {
            funny: 'Engraçado',
            casual: 'casual',
            excited: 'Entusiasmado',
            professional: 'Profissional',
            witty: 'Espirituoso.',
            sarcastic: 'Sarcástico',
            feminine: 'Feminino',
            masculine: 'Masculino',
            bold: 'Negrito',
            dramatic: 'Dramático',
            grumpy: 'Mal-humorado',
            secretive: 'Secretivo',
            respectful: 'Respeitoso',
            persuasive: 'Persuasivo',
        },
        contextOptions: {
            promotional: 'Promocional',
            introduction: 'Introdução',
            couponDiscount: 'Cupão/Desconto',
            recurringNewsletter: 'Boletim informativo recorrente',
            testimonial: 'Testemunho',
            coldOutreach: 'Abordagem fria',
            contentGiveaway: 'Conteúdo/Sorteio',
            other: 'Outro',
        },
        typeOptions: {
            outline: 'Esboço',
            introduction: 'Introdução',
            section: 'Secção',
        },
    },
};
